type MagnetometerLocations = Record<string, string>
export const Names: MagnetometerLocations = {
  ouj: 'Oulujärvi',
  muo: 'Muonio',
  iva: 'Ivalo',
  nur: 'Nurmijärvi',
}
